// extracted by mini-css-extract-plugin
export var measureBox = "_a0-0";